/**
 * Generic swipeable image carousel: native horizontal scroll-snap does the
 * actual swiping (works on touch with no JS at all); this just keeps the
 * dot indicators in sync with scroll position and click-to-jump. Looks for
 * every [data-carousel] on the page so it works on any template that uses
 * this markup pattern.
 */
(() => {
  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const container = carousel.parentElement;
    if (!container) return;
    const dots = container.querySelectorAll('[data-carousel-dot]');
    if (!dots.length) return;

    dots[0].classList.add('is-active');

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.carouselDot);
        carousel.scrollTo({ left: carousel.clientWidth * index, behavior: 'smooth' });
      });
    });

    let ticking = false;
    carousel.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const index = Math.round(carousel.scrollLeft / carousel.clientWidth);
          dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
          ticking = false;
        });
      },
      { passive: true }
    );
  });
})();
